import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography, TextField, Button, Alert } from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";
import { useTranslation } from "react-i18next";
import axiosPublic from "../api/axiosPublic";

export default function ForgotPassword() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axiosPublic.post("/api/app_user/forgot-password", { email });
            setSent(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#f5f0eb" }}>
            <Paper elevation={3} sx={{ p: 5, maxWidth: 440, width: "100%", borderRadius: 4, textAlign: "center" }}>
                <LockResetIcon sx={{ fontSize: 56, color: "#C4622D", mb: 2 }} />
                <Typography variant="h5" fontWeight={700} mb={1} sx={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
                    {t('auth.forgot_password_title')}
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={3}>
                    {t('auth.forgot_password_subtitle')}
                </Typography>

                {sent ? (
                    <>
                        <Alert severity="success" sx={{ mb: 3, textAlign: "left" }}>
                            {t('auth.reset_email_sent')}
                        </Alert>
                        <Button fullWidth variant="outlined" component="a" href="/login">
                            {t('auth.back_to_login')}
                        </Button>
                    </>
                ) : (
                    <Box component="form" onSubmit={handleSubmit}>
                        <TextField fullWidth label={t('auth.email')} type="email"
                                   value={email} onChange={e => setEmail(e.target.value)}
                                   required sx={{ mb: 3 }} />
                        <Button type="submit" fullWidth variant="contained" size="large"
                                disabled={loading}
                                sx={{ mb: 2, bgcolor: "#C4622D", "&:hover": { bgcolor: "#9A4A1F" } }}>
                            {loading ? t('common.sending') : t('auth.send_reset_link')}
                        </Button>
                        <Button fullWidth variant="text" component="a" href="/login">
                            {t('auth.back_to_login')}
                        </Button>
                    </Box>
                )}
            </Paper>
        </Box>
    );
}